"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTranscriptionInput = instanceOfTranscriptionInput;
exports.TranscriptionInputFromJSON = TranscriptionInputFromJSON;
exports.TranscriptionInputFromJSONTyped = TranscriptionInputFromJSONTyped;
exports.TranscriptionInputToJSON = TranscriptionInputToJSON;
/**
 * Check if a given object implements the TranscriptionInput interface.
 */
function instanceOfTranscriptionInput(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
function TranscriptionInputFromJSON(json) {
    return TranscriptionInputFromJSONTyped(json, false);
}
function TranscriptionInputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
    };
}
function TranscriptionInputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
    };
}
